import { PlanId, PLAN_RATES } from './rates';

// Modelo da planilha Simulador_planos.xlsx (aba "Cálculos") + regra do prazo (ZIG-390):
//   - D+1 = recebimento antecipado -> usa o COEFICIENTE (embute MDR + antecipacao):
//       cliente paga = valor * coef * parcelas ; lojista recebe = valor / (coef * parcelas).
//   - No vencimento = recebimento na data -> usa SO o MDR (sem antecipacao):
//       cliente paga = valor * (1 + MDR) ; lojista recebe = valor * (1 - MDR).
// Modalidades: absorve (lojista paga a taxa) x repassa (cliente paga a taxa).
// Debito nao antecipa -> D+1 == No vencimento (ambos so MDR).

export type Forma = 'debito' | 'avista' | number; // number = parcelas (2..21)

export interface Linha {
  absorve: number; // voce recebe (lojista absorve a taxa)
  repassa: number; // o cliente paga (taxa repassada ao cliente)
}

export interface Resultado {
  d1: Linha;
  vencimento: Linha;
}

const parcelasDe = (forma: Forma): number =>
  forma === 'debito' || forma === 'avista' ? 1 : forma;

const coeficienteDe = (plan: PlanId, forma: Forma): number => {
  const { coeficiente } = PLAN_RATES[plan];
  if (forma === 'avista') return coeficiente.avista;
  return coeficiente.parcelado[forma as number] ?? coeficiente.avista;
};

const mdrDe = (plan: PlanId, forma: Forma): number => {
  const { mdr } = PLAN_RATES[plan];
  if (forma === 'debito') return mdr.debito;
  if (forma === 'avista') return mdr.avista;
  return mdr.parcelado[forma] ?? mdr.avista;
};

export const simular = (
  valor: number,
  plan: PlanId,
  forma: Forma
): Resultado => {
  const zero: Linha = { absorve: 0, repassa: 0 };
  if (!valor) return { d1: zero, vencimento: zero };

  const mdr = mdrDe(plan, forma);
  const vencimento: Linha = {
    absorve: valor * (1 - mdr),
    repassa: valor * (1 + mdr),
  };

  // debito nao antecipa: D+1 e vencimento sao iguais (so MDR)
  if (forma === 'debito') return { d1: vencimento, vencimento };

  const n = parcelasDe(forma);
  const coef = coeficienteDe(plan, forma);
  const d1: Linha = {
    absorve: valor / (coef * n),
    repassa: valor * coef * n,
  };

  return { d1, vencimento };
};
